import axios from 'axios';
import _e from './_endpoints';

const formUrl:string = _e.getUrl('form');
const reportUrl:string = _e.getUrl('report');
const getBranchesUrl:string = _e.getUrl('branches');

const getForm = (branchId:string) => axios.get(`${formUrl}/${branchId}`);
const sendForm = (form:object) => axios.post(`${reportUrl}`, form);
const getBranches = () => axios.get(getBranchesUrl);

export default {
    getBranches,
    getForm,
    sendForm
}
